import { BASE_URL } from "@shared/constants";
import { StorageService } from "@libs/storage-service";

import { COUNTRIES_EXPORT_URL } from "./apiEndpoints";

export type ExportParams = {
  region?: string;
  status?: string;
  domain?: string;
};

const ALL_REGIONS = "All Regions";
const ALL_STATUS = "All Status";
const ALL_DOMAINS = "All Domains";

export const useExportCountries = () => {
  const exportCountries = async (params: ExportParams = {}) => {
    const searchParams = new URLSearchParams();

    if (params.region && params.region !== ALL_REGIONS) {
      searchParams.append("region", params.region);
    }

    if (params.status && params.status !== ALL_STATUS) {
      searchParams.append("status", params.status.toLowerCase());
    }

    if (params.domain && params.domain !== ALL_DOMAINS) {
      searchParams.append("domain", params.domain.toLowerCase());
    }

    const query = searchParams.toString();
    const url = query
      ? `${BASE_URL}${COUNTRIES_EXPORT_URL}?${query}`
      : `${BASE_URL}${COUNTRIES_EXPORT_URL}`;

    const token = StorageService.get<string>("accessToken");
    const res = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    const contentType = res.headers.get("content-type") || "";
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || res.statusText);
    }
    if (contentType.includes("application/json")) {
      const json = await res.json();
      const msg = (json as { message?: string }).message;
      throw new Error(msg || "Export failed");
    }
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "countries-export.csv";
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return { exportCountries };
};
